import React from 'react';
import HeroSection from './HeroSection';
import OverviewSection from './OverviewSection';
import ProjectGoalsSection from './ProjectGoalsSection';
import Timeline from './Timeline';
import Roadmap from './Roadmap';
import ImpactSection from './ImpactSection';
import '../../styles/about/about.css';

const About = () => {
	return (
		<div>
			<HeroSection />
			<OverviewSection />
			<ProjectGoalsSection />
			<Timeline />
			<Roadmap />
			<ImpactSection />
		</div>
	);
};

export default About;
